/**
 * In dev, the Vite proxy (vite.config.ts) forwards /api/*, /health, /openapi,
 * and /scalar to VITE_API_BASE_URL, so an empty base ("") sends requests
 * relative to the current origin and the proxy handles routing.
 *
 * In production, set VITE_API_BASE_URL to the deployed API origin
 * (e.g. https://api.caldera.app) so absolute URLs are used.
 */
export const config = {
  apiBase: import.meta.env.VITE_API_BASE_URL ?? "",
  azureAd: {
    tenantId: import.meta.env.VITE_AZURE_AD_TENANT_ID as string | undefined,
    clientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID as string | undefined,
    apiScope: import.meta.env.VITE_AZURE_AD_API_SCOPE as string | undefined,
  },
  isAuthEnabled(): boolean {
    return Boolean(this.azureAd.tenantId && this.azureAd.clientId);
  },
  /** ICS feeds are served by the API host only — never the static web app. */
  calendarFeedBase(): string {
    if (this.apiBase) {
      return this.apiBase.replace(/\/$/, "");
    }
    // Local dev: Vite proxies /calendar to the API.
    if (typeof window !== "undefined") {
      const host = window.location.hostname;
      if (host === "localhost" || host === "127.0.0.1") {
        return window.location.origin;
      }
    }
    return "";
  },
};
